import React from 'react';
import { FormattedMessage } from 'react-intl';
import ColorLink from '@/components/UIKit/ColorLink';

const Purchase = () => (
  <div>
    <FormattedMessage id="PAMA_ACCESS_MESSAGE" defaultMessage="" />{' '}
    <ColorLink to="https://uamap.online/ucoins" color="#e4c557">
      <FormattedMessage id="UCOINS_TITLE" />
    </ColorLink>
  </div>
);

export default Purchase;
